import React, { Component } from 'react';

import { LinkContainer } from 'react-router-bootstrap';

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

class ContactCourseCard extends Component {
  render() {
    return (
      <Container className='d-flex justify-content-center'>
        <Card
          style={{ borderRadius: 70 }}
          className='shadow-sm contact-card-width border-action-card mx-3 mx-md-5 my-3'>
          <Card.Body>
            <Row className='custom-vertical-align'>
              <Col xs={12} md={8} className='pl-md-5 mb-3 mb-md-0'>
                <Card.Text className='text-center'>
                  Capacitaciones en aulas virtuales así como también presenciales lideradas por nuestro staff de
                  profesionales.
                </Card.Text>
              </Col>
              <Col xs={12} md={4} className='text-center contact-card-btn'>
                <LinkContainer to={'/contact'}>
                  <Button variant='' size='lg' className='btn-action-card btn-danger shadow-sm px-3'>
                    Contáctanos
                  </Button>
                </LinkContainer>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    );
  }
}

export default ContactCourseCard;
